export default [{
  path: '/devices',
  name: 'devices',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/devices/index')
}]
